// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import 'trix';
import '@rails/actiontext';
import Rails from '@rails/ujs';
import { Turbo } from '@hotwired/turbo-rails';
window.Turbo = Turbo;
import * as ActiveStorage from '@rails/activestorage';
import 'channels';

Rails.start();
ActiveStorage.start();

import 'controllers';
import 'stylesheets/application.scss';
require('trix');
require('@rails/actiontext');

import '../components/registerComponents';
document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('two-factor-auth')) {
    document.documentElement.classList.add('two-factor-auth-parent');
  }
});

window.AppHelpers = {
  initCharCounter: function(inputId, counterId) {
            const inputEl = document.getElementById(inputId);
            const counterEl = document.getElementById(counterId);
            if (!inputEl || !counterEl) {
              console.warn(`Counter initialization failed: ${inputId} or ${counterId} not found.`);
              return;
            }
            const maxAllowed = parseInt(inputEl.getAttribute('maxlength'));
            const updateCount = () => {
              let currentLength = inputEl.value.length;
              let remaining = maxAllowed - currentLength;
              if(remaining<=0) {
                inputEl.value = inputEl.value.slice(0, maxAllowed);
                currentLength = inputEl.value.length;
                remaining = maxAllowed - currentLength;
                counterEl.innerHTML = `${currentLength}/${maxAllowed}`;
                counterEl.style.color = remaining <= 10 ? 'red' : 'inherit';
              } else{
                counterEl.innerHTML = `${currentLength}/${maxAllowed}`;
                counterEl.style.color = remaining <= 10 ? 'red' : 'inherit';
              }
            };
            updateCount();
            inputEl.addEventListener('input', updateCount);
          }
};